import { GeneralTable } from "@/shared/components/ui";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Alert, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { useDownloadPdf, useFetchWorkOrder, useGetFlotaByUser } from "../actions/noc-module.actions";
import { OrdenTrabajoNoc } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { useTableColumnsWorkOrder } from "../hooks/useTableColumnsWorkOrder";
import { RemoveRedEye, PictureAsPdf } from '@mui/icons-material';
import { useNavigate } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared";

export default function TabOrdenTrabajoNocRealizadas() {

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoVerPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocNav;
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;
    const area = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.area;

    const { columnsWorkOrder } = useTableColumnsWorkOrder();

    const { pagination, setPagination } = useTableFilter();
    const { pageIndex, pageSize } = pagination;
    const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();

    const { data: flotaUserRes } = useGetFlotaByUser(username) as any;
    const codigoFlota = flotaUserRes?.data;

    const {
        isLoading,
        data: workOrderRes,
        isRefetching
    } = useFetchWorkOrder({
        page: pageIndex,
        page_size: pageSize,
        orderStatus: 'REALIZADO',
        ...(codigoFlota?.data.length > 0 && { fleetCode: codigoFlota?.data?.[0].codigo }),
        ...filterObject,
    });

    const onView = (original: OrdenTrabajoNoc) => {
        navigate(`${returnUrlOrdenTrabajoVerPage}/ver/${original.workOrderId}`);
    };

    // const onGeneratePdf = (original: OrdenTrabajoNoc) => {
    //     useDownloadPdf(original.workOrderId);
    // };

    const { mutate: downloadPdf, isPending } = useDownloadPdf();

    const onGeneratePdf = (original: OrdenTrabajoNoc) => {
        downloadPdf(original.workOrderId, {
            onSuccess: (blob: any) => {
                console.log('PDF:', blob);
                console.log('Tipo:', blob.type);
                console.log('Tamaño:', blob.size);

                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
            },
        });
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>

            </Grid>
            <Grid item xs={12}>
                {area == "TEC-01" && codigoFlota?.data.length <= 0 ?
                    <Grid item xs={12}>
                        <Alert severity="warning" sx={{ bgcolor: "warning.light" }}>
                            <Typography variant="body2">
                                <strong>Información:</strong> Por el momento no puede visualizar la información de actividades, por favor notificar a Desarrollo para su revisión.
                            </Typography>
                        </Alert>
                    </Grid>
                    :
                    <GeneralTable<OrdenTrabajoNoc>
                        columns={columnsWorkOrder}
                        data={workOrderRes?.data.content || []}

                        isLoading={isLoading}
                        isRefetching={isRefetching}
                        // // search
                        enableGlobalFilter={false}
                        // onGlobalFilterChange={setGlobalFilter}
                        // // pagination
                        pagination={pagination}
                        onPaging={setPagination}
                        rowCount={workOrderRes?.data?.totalElements}

                        ///* filters - server side
                        enableManualFiltering={true}
                        columnFilters={columnFilters}
                        onColumnFiltersChange={setColumnFilters}
                        enableSorting={false}

                        enableColumnActions={true}
                        positionActionsColumn='first'

                        // // actions
                        actionsColumnSize={120}
                        // crud
                        enableEditing={true}
                        editIcon={<RemoveRedEye color="success" />}
                        toolTipTitleEditIcon={"Visualizar"}
                        onEdit={onView}

                        showCustomActionBtnSpace={true}
                        customActionBtnSpace={(row) => (
                            <Tooltip title="Ver Documento">
                                <IconButton
                                    onClick={() => {
                                        onGeneratePdf(row as OrdenTrabajoNoc);
                                    }}
                                    disabled={isPending}
                                >
                                    <PictureAsPdf color="primary" />
                                </IconButton>
                            </Tooltip>
                        )}
                        canDelete={false}
                    />
                }
            </Grid>
        </Grid>
    );
}